export const pageTypeSubstitutes: Record<string, string|undefined> = {
    add: 'view',
};
